// Utility functions for managing cookies with security best practices

export const setCookie = (name, value, days = 7) => {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  
  // Get domain dynamically - use .neuranet.io in production, otherwise no domain for local development
  const domain = window.location.hostname === 'localhost' ? '' : '.neuranet.io';
  const domainPart = domain ? `domain=${domain};` : '';
  
  const cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; expires=${date.toUTCString()}; path=/; ${domainPart} SameSite=Lax; Secure`;
  document.cookie = cookie;
};

export const getCookie = (name) => {
  const cookies = document.cookie.split(';');
  const cookie = cookies.find(c => c.trim().startsWith(`${name}=`));
  
  if (!cookie) return null;
  
  try {
    return JSON.parse(decodeURIComponent(cookie.split('=')[1].trim()));
  } catch (error) {
    console.error('Error parsing cookie:', error);
    return null;
  }
};

export const removeCookie = (name) => {
  const domain = window.location.hostname === 'localhost' ? '' : '.neuranet.io';
  const domainPart = domain ? `domain=${domain};` : '';
  
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; ${domainPart} SameSite=Lax; Secure`;
};